import { ThunkDispatch } from "../store";
import { allTutorLoaded } from "../Tutors/actions";

export async function addThisTutorInfos (data:any) {
    const res = await fetch(`${process.env.REACT_APP_API_SERVER}/tutor/addThisTutorInfos`, {
        method: 'POST',
        headers: {
            "Content-Type":"application/json",
            Authorization:`Bearer ${localStorage.getItem('token')}`,

        },
        body: JSON.stringify(data)
    })
    let result : any= await res.json()
    console.log(result);
    if(res.status === 500){
        return async (dispatch:ThunkDispatch) => {
            
            console.log(result);
        }
    } else {
        const res02 = await fetch(`${process.env.REACT_APP_API_SERVER}/tutor/loadAllTutorInfos`, {
            method: 'GET',
            headers: {
                "Content-Type":"application/json",
                Authorization:`Bearer ${localStorage.getItem('token')}`,
            }
        })
        let result02 = await res02.json();
        return async (dispatch:ThunkDispatch) => {
            
            dispatch(allTutorLoaded(result02.data,result02.employmentStatuses,result02.genreTypes, result02.ageGroups));

        }
    }
}



